var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('b-container',{staticClass:"main",attrs:{"fluid":"md"}},[_c('Header'),_c('router-view',{key:_vm.$route.fullPath})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }